import moment from "moment";

function formatDate(dateString) {
  if (typeof dateString !== "string") {
    throw new Error("Invalid date input");
  }

  // const originalDate = new Date(dateString);
  // const formattedDate = originalDate.toISOString().split("T")[0];

  const formattedDate = moment(dateString).format("DD-MM-YYYY");
  return formattedDate;
}

export default formatDate;
